import React, { useEffect, useState } from 'react';
import { signIn } from 'aws-amplify/auth';

interface DevAutoLoginProps {
  children: React.ReactNode;
}

const DevAutoLogin: React.FC<DevAutoLoginProps> = ({ children }) => {
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const autoLoginInDev = async () => {
      // Skip auto-login for admin routes since user should authenticate through AdminLoginCustom
      if (window.location.pathname.startsWith('/admin')) {
        setIsChecking(false);
        return;
      }

      // Only auto-login in development and sandbox environments
      const isDev = process.env.NODE_ENV === 'development';
      const isSandbox = process.env.REACT_APP_AMPLIFY_ENVIRONMENT === 'sandbox' ||
                       window.location.hostname === 'localhost';

      // Temporarily disable auto-login until admin users are properly seeded
      if (!isDev || !isSandbox) {
        setIsChecking(false);
        return;
      }
      
      // Skip auto-login for now
      setIsChecking(false);
      return;

      try {
        // Try to sign in with the sandbox admin credentials
        await signIn({
          username: 'wilhelm@mintkitchen.de',
          password: 'DevPass123!'
        });
        
        console.log('🔐 Auto-login successful for development environment');
        setIsChecking(false);
      } catch (signInError: any) {
        console.warn('🔐 Auto-login failed:', signInError.message);
        // Don't show error for auto-login failures, just proceed normally
        setIsChecking(false);
      }
    };

    autoLoginInDev();
  }, []);

  if (isChecking) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        flexDirection: 'column',
        background: '#f9fafb'
      }}>
        <div style={{ marginBottom: '16px' }}>🔐 Checking authentication...</div>
        <div style={{ fontSize: '0.875rem', color: '#6b7280' }}>
          Development auto-login in progress
        </div>
      </div>
    );
  }



  return <>{children}</>;
};

export default DevAutoLogin;
